import { Upload } from 'lucide-react'
import { Button } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { MISC_PRIMARY, MISC_PRIMARY_HOVER } from '../../theme/onboardingTheme'

export function LicenseImportButton() {
  const { dispatch } = useOnboarding()

  return (
    <Button
      type="button"
      onClick={() => dispatch({ type: 'TOAST', message: 'Import XML or CSV would open (demo).' })}
      startIcon={<Upload size={16} aria-hidden />}
      sx={{
        display: 'inline-flex',
        flexShrink: 0,
        alignItems: 'center',
        gap: 0.75,
        borderRadius: '8px',
        backgroundColor: MISC_PRIMARY,
        px: 2,
        py: 1,
        fontSize: 14,
        fontWeight: 600,
        color: '#ffffff',
        boxShadow: 1,
        textTransform: 'none',
        '&:hover': { backgroundColor: MISC_PRIMARY_HOVER },
      }}
    >
      Import XML, CSV
    </Button>
  )
}
